import React, {useEffect, useState} from "react";
import {Link, usePage} from "@inertiajs/react";
import {PiCaretRight, PiList} from "react-icons/pi";

/** Liegt der Pfad `path` auf oder unter dem Knoten `node`? */
const istImZweig = (node, path) => !!path && (path === node.path || path.startsWith(node.path + "/"));

/**
 * Ein Knoten der Seitenleiste. Knoten mit Kindern sind ein Disclosure-Button
 * (aria-expanded) neben dem Link auf die eigene Seite; der Aufklappzustand
 * startet aus der aktiven Seite und bleibt beim Seitenwechsel erhalten.
 */
function Knoten({node, activePath, level}) {
    const hatKinder = node.children.length > 0;
    const imZweig = istImZweig(node, activePath);
    const [offen, setOffen] = useState(imZweig);
    const aktiv = activePath === node.path;

    useEffect(() => {
        if (imZweig) setOffen(true);
    }, [imZweig]);

    return (
        <li className="documents-nav__item">
            <div className={`documents-nav__row documents-nav__row--level${level}${aktiv ? " is-active" : ""}`}>
                {hatKinder && (
                    <button
                        type="button"
                        className={`documents-nav__toggle${offen ? " is-open" : ""}`}
                        aria-expanded={offen}
                        aria-label={`${node.title} ${offen ? "zuklappen" : "aufklappen"}`}
                        onClick={() => setOffen(!offen)}
                    >
                        <PiCaretRight aria-hidden="true" />
                    </button>
                )}
                <Link
                    href={`/documents/${node.path}`}
                    className="documents-nav__link"
                    aria-current={aktiv ? "page" : undefined}
                >
                    {node.title}
                </Link>
            </div>
            {hatKinder && offen && (
                <ul className="documents-nav__list documents-nav__list--sub list-unstyled">
                    {node.children.map((kind) => (
                        <Knoten key={kind.id} node={kind} activePath={activePath} level={level + 1} />
                    ))}
                </ul>
            )}
        </li>
    );
}

/**
 * Eigenes Layout des Bereichs Dokumente (Intranet-Stil): links eine Baum-
 * Navigation in kleiner Schrift, rechts der Inhalt. Mobil (< 768 px) wird die
 * Navigation zu einem aufklappbaren Menü über dem Inhalt.
 */
export default function DocumentsLayout({children}) {
    const {tree, activePath} = usePage().props;
    const [mobilOffen, setMobilOffen] = useState(false);

    useEffect(() => {
        setMobilOffen(false);
    }, [activePath]);

    return (
        <div className="documents-area">
            <button
                type="button"
                className="documents-area__toggle btn btn-outline-secondary btn-sm"
                aria-expanded={mobilOffen}
                aria-controls="documents-nav"
                onClick={() => setMobilOffen(!mobilOffen)}
            >
                <PiList aria-hidden="true" /> Navigation
            </button>
            <nav
                id="documents-nav"
                className={`documents-nav${mobilOffen ? " is-open" : ""}`}
                aria-label="Dokumente"
            >
                <ul className="documents-nav__list list-unstyled">
                    {tree.map((node) => (
                        <Knoten key={node.id} node={node} activePath={activePath} level={1} />
                    ))}
                </ul>
            </nav>
            <main className="documents-area__content">{children}</main>
        </div>
    );
}
